import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import divScroll from "@/components/div-scroll/div-scroll.vue";
import { State } from "vuex-class";
let PiMenu = class PiMenu extends Vue {
    constructor() {
        super(...arguments);
        this.theme2 = "light";
        this.openNames = [];
        this.menuShow = false;
    }
    getVisible() {
        this.openNames = [this.getTowMenu(this.menuId)];
    }
    zoomClick() {
        this.$emit("collapse");
    }
    getTowMenu(key) {
        const arr = key.split("-");
        return arr[0] + "-" + arr[1];
    }
    smallMenuClick(item) {
        this.$router.push(item.url);
    }
};
__decorate([
    Prop({ default: "" })
], PiMenu.prototype, "menuId", void 0);
__decorate([
    Prop({ default: true })
], PiMenu.prototype, "isCollapse", void 0);
__decorate([
    State("sys")
], PiMenu.prototype, "sys", void 0);
__decorate([
    Watch("menuId")
], PiMenu.prototype, "getVisible", null);
PiMenu = __decorate([
    Component({
        components: {
            "pi-div-scroll": divScroll,
        },
    })
], PiMenu);
export default PiMenu;
